<!-- 添加排行榜商品弹窗组件 -->
<template>
  <a-modal
    :maskClosable="false"
    v-model="visible"
    title="添加排行榜商品"
    :confirm-loading="submitLoading"
    @ok="onSubmit"
    @cancel="handleCancel"
    width="500px"
  >
    <a-form-model :rules="rules" ref="formModel" size="small" :model="form">
      <a-form-model-item label="商品名称">
        <a-input :value="goodsData.goods_name" disabled />
      </a-form-model-item>

      <a-form-model-item label="类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择类型">
          <a-select-option :value="1">新品</a-select-option>
          <a-select-option :value="2">经典</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="品牌" prop="brand_id">
        <a-select v-model="form.brand_id" placeholder="请选择品牌">
          <a-select-option
            :value="item.id"
            v-for="(item, index) in availableBrands"
            :key="index"
            >{{ item.brand_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="排序" prop="rank">
        <a-select v-model="form.rank" placeholder="请选择排序">
          <a-select-option :value="i" v-for="i in 8" :key="i">{{
            i
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { GoodsRank_add } from "@/api/goods";
import { brand_index } from "@/api/goods";

export default {
  name: "AddRankModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    goodsData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitLoading: false,
      brandData: [], // 所有品牌数据
      form: {
        goods_id: null,
        brand_id: undefined,
        rank: undefined,
        type: undefined,
      },
      rules: {
        brand_id: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        rank: [{ required: true, message: "请选择排序", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // 可选的品牌列表，排除商品原有的品牌ID，只显示4,5,6
    availableBrands() {
      return this.brandData.filter((brand) => {
        return [4, 5, 6].includes(brand.id);
      });
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.form.goods_id = this.goodsData.id;
        this.getBrandData();
      }
    },
  },
  methods: {
    // 获取品牌数据
    async getBrandData() {
      try {
        const res = await brand_index({ page: 1, limit: 1000 });
        this.brandData = res.list || [];
      } catch (error) {
        console.error("获取品牌数据失败:", error);
      }
    },

    // 取消弹窗
    handleCancel() {
      this.submitLoading = false;
      this.visible = false;
      this.form = {
        goods_id: null,
        brand_id: undefined,
        rank: undefined,
        type: undefined,
      };
      this.$emit("cancel");
    },

    // 提交表单
    async onSubmit() {
      this.$refs.formModel.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            const params = {
              goods_id: this.form.goods_id,
              brand_id: this.form.brand_id,
              rank: this.form.rank,
              type: this.form.type,
            };

            await GoodsRank_add(params);
            this.$message.success("添加排行榜商品成功");

            setTimeout(() => {
              this.submitLoading = false;
              this.visible = false;
              this.form = {
                goods_id: null,
                brand_id: undefined,
                rank: undefined,
                type: undefined,
              };
              this.$emit("success");
            }, 1500);
          } catch (error) {
            this.submitLoading = false;
            console.error("添加失败:", error);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script> 